// Currency system types and configuration
export type SupportedCurrency = 'INR' | 'SAR';

export interface CurrencyConfig {
  code: SupportedCurrency;
  name: string;
  symbol: string;
  locale: string;
  decimalPlaces: number;
}

export const SUPPORTED_CURRENCIES: Record<SupportedCurrency, CurrencyConfig> = {
  INR: {
    code: 'INR',
    name: 'Indian Rupee',
    symbol: '₹',
    locale: 'en-IN',
    decimalPlaces: 2,
  },
  SAR: {
    code: 'SAR',
    name: 'Saudi Riyal',
    symbol: 'SAR',
    locale: 'en-US',
    decimalPlaces: 2,
  },
} as const;

export const DEFAULT_CURRENCY: SupportedCurrency = 'INR';

// Type for vendor currency preference
export interface VendorCurrencyPreference {
  vendor_id: string;
  preferred_currency: SupportedCurrency;
}

// Utility type for currency-aware components
export interface CurrencyAwareProps {
  currency?: SupportedCurrency;
}